mama-gallery-item {
  text-align: center;
  cursor: pointer;
  position: relative;

  &:first-child [slot='preview'] {
    display: none;
  }

  &:not(:first-child) [slot='picture'] {
    display: none;
  }

  .search-icon,
  .layer {
    z-index: 1;
    display: none;
    opacity: 1;
    background-color: rgba($brand-primary, 0.75);
    width: 100%;
    height: 100%;
    position: absolute;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    will-change: opacity;
    transition: $transition-ease-out;
    color: $white;
    line-height: 1.375rem;

    svg {
      fill: $white;
      width: 3rem;
      height: 3rem;
    }

    strong {
      font-size: 1.125rem;
      line-height: 1.6875rem;

      @include media-breakpoint-up(md) {
        font-size: 1.25rem;
      }
    }
  }

  &:not(:hover) .search-icon {
    opacity: 0;
  }

  &:nth-child(n + 4) .layer {
    display: flex;
  }

  &:nth-child(n + 5) {
    display: none;
  }

  @include media-breakpoint-down(sm) {
    &:nth-child(n + 3) .layer {
      display: flex;
    }
    &:nth-child(n + 4) {
      display: none;
    }
  }

  .description {
    display: none;
  }
}

.gallery-item {
  position: relative;

  picture {
    text-align: center;
  }

  .modal & {
    [slot='preview'] {
      display: none;
    }
  }

  img {
    max-height: calc(100vh - 10rem);
  }
}
